import {Pipe, PipeTransform} from "@angular/core";

import {CalendarView} from "@progress/kendo-angular-dateinputs";
import {HijriDate, HijriDateService} from "../services/hijri.date.service";
import * as moment from "moment";

@Pipe({
	name: 'cpHijriDate',
	pure: true
})
export class HijriDatePipe implements PipeTransform {

	constructor(private hijriDateService: HijriDateService) {
	}

	transform(hijriDatesDictionary: { [date: string]: HijriDate }, date: Date, format?: string, view?: CalendarView): string {
		if (!date) {
			return;
		}
		const dateMoment = moment(date).startOf("day");

		if (view) {
			switch (view) {

				case "month":
					const startOfMonthString = moment(date).startOf("month").valueOf();
					const endOfMonthString = moment(date).endOf("month").startOf("day").valueOf();

					let startHijri, endHijri;
					let startResult, endResult;
					if (hijriDatesDictionary[startOfMonthString] && hijriDatesDictionary[endOfMonthString]) {
						startHijri = hijriDatesDictionary[startOfMonthString];
						endHijri = hijriDatesDictionary[endOfMonthString];
						const show2Years = startHijri.year != endHijri.year;
						startResult = this.hijriDateService.formatHijriDate(startHijri, format ? format : (show2Years ? "iMMMM iYYYY" : "iMMMM"));
						endResult = this.hijriDateService.formatHijriDate(endHijri, format ? format : "iMMMM iYYYY");
						return startResult + " - " + endResult;
					} else {
						this.hijriDateService.debounceGetHijriDatesInMonth(date);
					}
					break;

				case "year":
					const startOfYearString = moment(date).startOf("year").valueOf();
					const endOfYearString = moment(date).endOf("year").startOf("day").valueOf();

					if (hijriDatesDictionary[startOfYearString] && hijriDatesDictionary[endOfYearString]) {
						return this.hijriDateService.formatHijriDate(hijriDatesDictionary[startOfYearString], "iYYYY") + " - " + this.hijriDateService.formatHijriDate(hijriDatesDictionary[endOfYearString], "iYYYY");
					} else {
						this.hijriDateService.debounceGetHijriDatesInYear(date);
					}
					break;

				case "decade":
					const year = moment(date).year();
					const startOfDecadeYear = Math.trunc(year / 10) * 10;
					const endOfDecadeYear = startOfDecadeYear + 9;

					let ronzaStart: Date = new Date(startOfDecadeYear, 0, 1);
					let ronzaEnd: Date = new Date(endOfDecadeYear, 0, 1);

					let startOfDecade = moment(ronzaStart).valueOf();
					let endOfDecade = moment(ronzaEnd).valueOf();

					if (hijriDatesDictionary[startOfDecade] && hijriDatesDictionary[endOfDecade]) {
						return this.hijriDateService.formatHijriDate(hijriDatesDictionary[startOfDecade], "iYYYY") + " - " + this.hijriDateService.formatHijriDate(hijriDatesDictionary[endOfDecade], "iYYYY");
					} else {
						this.hijriDateService.debounceGetHijriDatesInDecade(date);
					}
					break;
				case "century":
					return "";
			}
		} else {
			if (hijriDatesDictionary && hijriDatesDictionary[dateMoment.valueOf()]) {
				return this.hijriDateService.formatHijriDate(hijriDatesDictionary[dateMoment.valueOf()], format);
			} else {
				if (format && format == 'iD') {
					this.hijriDateService.debounceGetHijriDatesInMonth(date);
				} else {
					this.hijriDateService.getHijriDate(date);
				}
			}
		}
		return "";
	}
}
